/** Browser storage that never throws (private mode, blocked storage, previews). */
export function readJson<T>(key: string, fallback: T, store: 'local' | 'session' = 'local'): T {
  try {
    const raw = (store === 'local' ? window.localStorage : window.sessionStorage).getItem(key);
    return raw ? (JSON.parse(raw) as T) : fallback;
  } catch {
    return fallback;
  }
}

export function writeJson(key: string, value: unknown, store: 'local' | 'session' = 'local'): void {
  try {
    (store === 'local' ? window.localStorage : window.sessionStorage).setItem(key, JSON.stringify(value));
  } catch {
    /* storage unavailable: feature degrades, app keeps working */
  }
}

export function removeKey(key: string, store: 'local' | 'session' = 'local'): void {
  try {
    (store === 'local' ? window.localStorage : window.sessionStorage).removeItem(key);
  } catch {
    /* ignore */
  }
}

export function removeByPrefix(prefix: string): void {
  for (const s of [window.localStorage, window.sessionStorage]) {
    try {
      for (let i = s.length - 1; i >= 0; i--) {
        const k = s.key(i);
        if (k?.startsWith(prefix)) s.removeItem(k);
      }
    } catch {
      /* ignore */
    }
  }
}
